import { useState, useEffect } from 'react';
import { TICK_SESSION_DURATION_MS } from '../helper/pollingConfig';

export function useSessionDuration(startDate: string | null | undefined) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!startDate) return;

    const start = new Date(startDate).getTime();

    const tick = () => {
      setElapsed(Math.floor((Date.now() - start) / 1000));
    };

    tick();
    const interval = setInterval(tick, TICK_SESSION_DURATION_MS);
    return () => clearInterval(interval);
  }, [startDate]);

  return elapsed;
}
